module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zen-import text-dark"
  }, [_c('div', {
    staticClass: "zen-hero-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "zen-import-container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.zen_import.import_from_zen')))]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "box"
  }, [_c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  })], 1) : [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label d-label--white"
  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.choose_version')))]), _vm._v(" "), (_vm.schedules.length < 1) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.zen_import.you_have_no_created_any_versions')) + "\n        ")]) : _c('div', {
    staticClass: "zen-schedules"
  }, [_c('div', {
    staticClass: "zen-schedule zen-schedule__header"
  }, [_c('div', {
    staticClass: "zen-schedule__left"
  }), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.last_updated')))])])]), _vm._v(" "), _vm._l((_vm.schedules), function(schedule) {
    return _c('div', {
      key: schedule.scheduleUuid,
      staticClass: "zen-schedule",
      class: {
        'zen-schedule--selected': _vm.isSelected(schedule.scheduleUuid)
      },
      on: {
        "click": function($event) {
          return _vm.setActiveSchedule(schedule.scheduleUuid)
        }
      }
    }, [_c('div', {
      staticClass: "zen-schedule__left"
    }, [_c('div', {
      staticClass: "d-radio",
      class: {
        'd-radio--selected': _vm.isSelected(schedule.scheduleUuid)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "zen-schedule__title"
    }, [_vm._v(_vm._s(schedule.title))])]), _vm._v(" "), _c('p', {
      staticClass: "zen-schedule__modified"
    }, [_c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'right'
        }),
        expression: "{\n                  arrow: true,\n                  placement : 'right'\n                }"
      }],
      staticClass: "zen-schedule__modified__date hint--right",
      attrs: {
        "content": _vm.showDate(schedule.modifiedAt)
      }
    }, [_vm._v(_vm._s(_vm.showHumanizeDate(schedule.modifiedAt)))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.choose_schoolyear')))]), _vm._v(" "), _c('ChangeSchoolYear', {
    staticStyle: {
      "max-width": "210px"
    },
    attrs: {
      "whiteTheme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.insert_in_week')))]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "type": _vm.datepickerType,
      "lang": _vm.datepickerLang,
      "value-type": "YYYY-MM-DD",
      "format": _vm.datepickerFormat
    },
    model: {
      value: (_vm.theDate),
      callback: function($$v) {
        _vm.theDate = $$v
      },
      expression: "theDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [(_vm.schedules.length < 1) ? _c('button', {
    staticClass: "bttn bttn--primary bttn--large bttn--primary--disabled"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.zen_import.insert_schedules')) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isSendingData && _vm.schedules.length > 0) ? _c('button', {
    staticClass: "bttn bttn--primary bttn--large",
    on: {
      "click": _vm.submitSchudules
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.insert_schedules')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSendingData) ? _c('button', {
    staticClass: "bttn bttn--primary bttn--large bttn--loading"
  }) : _vm._e()])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b10cf5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZenImport/ZenImport.vue
// module id = 1635
// module chunks = 1